
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWarningBadge as ObiWarningBadgeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-warning-badge.js';
 
 
 

 
 export const ObiWarningBadge = createComponent({
   react: React,
   tagName: 'obi-warning-badge',
   elementClass: ObiWarningBadgeElement,
   events: {
     
   }
  });
 
 